import React, { useCallback } from 'react';
import classNames from 'classnames';
import FluidButton from 'ui/FluidButton';
import { useDispatch, useSelector } from 'react-redux';
import { openUploadAttachmentModalAction } from 'store/modules/taskManagement/actions';
import { TaskUploadFileModal } from './TaskUploadFileModal';
import { TaskAttachmentsTable } from './TaskAttachmentsTable';
import { getListAttachmentsLoadingSelector, listAttachmentsSelector } from 'store/modules/taskManagement/selectors';
import { ITaskAttachment } from 'services/TaskManagementApi/types/TaskManagementResponse';

export interface ITaskAttachmentsProps {
  className?: string;
  taskId: string;
}

export const TaskAttachments: React.FC<ITaskAttachmentsProps> = (props) => {
  const dispatch = useDispatch();
  const taskAttachments: ITaskAttachment[] = useSelector(listAttachmentsSelector);
  const taskAttachmentsLoading = useSelector(getListAttachmentsLoadingSelector);

  const handleAttachFile = useCallback(() => {
    dispatch(openUploadAttachmentModalAction());
  }, [dispatch]);
  
  return (
    <div className={classNames(props.className, 'task-reminders flex flex-col items-start gap-[10px]')}>
      <p className="font-pt-sans text-black m-0 text-[16px]"><b>Attachments</b> ({taskAttachments.length})</p>
      <TaskAttachmentsTable taskId={props.taskId} taskAttachments={taskAttachments} taskAttachmentsLoading={taskAttachmentsLoading} />
      <FluidButton type="secondary" onClick={handleAttachFile}>
        Attach File
      </FluidButton>
      <TaskUploadFileModal taskId={props.taskId} />
    </div>
  )
};
